import PropTypes from 'prop-types';
import React from 'react';
import shortId from 'shortid';
import './Loader.css';

const Loader = React.memo(({ title }) => {
  const id = shortId.generate();
  const idAria = `${id}-aria`;

  return (
    <svg
      className="loader"
      role="img"
      viewBox="0 0 100 100"
      aria-labelledby={idAria}
      xmlns="http://www.w3.org/2000/svg">
      <title id={idAria}>{title}</title>
      <circle cx="50" cy="50" r="45" />
    </svg>
  );
});

Loader.propTypes = {
  title: PropTypes.string
};

Loader.defaultProps = {
  title: 'Loading, please wait ...'
};

export default Loader;
